import { capitalize } from "@utils/convert-string";
import { useTranslation } from "react-i18next";

const useReport = () => {
    const { t } = useTranslation();

    const addCommaToBigInt = (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const convertDateWithDay = (date) => {
        if (!date) return "";

        const newDate = new Date(date);
        const currentLanguage = localStorage.getItem("i18nLng");
        let countryCode = "en-US";
        if (currentLanguage === "ko") {
            countryCode = "ko-KR";
        } else if (currentLanguage === "ja") {
            countryCode = "ja-JP";
        }

        const localizedDay = Intl.DateTimeFormat(countryCode, { weekday: "short" }).format(newDate); //여기 현재 언어팩으로

        return `${newDate?.toLocaleDateString("en-CA")} (${localizedDay})`;
    };

    const shortenedCondition = (condition) => {
        if (!condition) return "";
        const shortCondition = capitalize(condition.split("_").at(-1), true);

        return t(`common::label::REPORT_${shortCondition}`, shortCondition);
    };

    return { addCommaToBigInt, convertDateWithDay, shortenedCondition };
};

export default useReport;
